module.exports = __webpack_public_path__ + "static/media/md-information.499bd6bc.svg";